<template>
    <div class="rounded-image-with-content">
        <div class="content-wrapper">
            <div class="content">
                <div class="content-items">
                    <ContentComponentItem
                        v-for="(component, key) in data.content"
                        :key="key"
                        :background="data.roundedImage.backgroundColor"
                        :data="component"
                        :page-type="pageType"
                    />
                </div>
            </div>
        </div>

        <div class="image-wrapper">
            <ComponentRoundedImage
                :data="data.roundedImage"
                :has-eager-image="hasEagerImage"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ComponentRoundedImageContentFragment } from '@/graphql/api'
import { cmsColorToButtonColor } from '@/components/cms'

import ContentComponentItem from '@/components/cms/component/ContentComponentItem.vue'
import ComponentRoundedImage from '@/components/cms/component/ComponentRoundedImage.vue'
import type { PageType } from '@/components/cms/component/content/ContentButton.vue'

const props = defineProps<{
    data: ComponentRoundedImageContentFragment
    hasEagerImage?: boolean
    pageType: PageType
}>()

const backgroundColor = computed(() =>
    cmsColorToButtonColor(props.data.roundedImage.backgroundColor)
)
</script>

<style lang="scss" scoped>
.rounded-image-with-content {
    background-color: v-bind(backgroundColor);
    padding: 80px 0 0;

    @include min-width(1024) {
        display: flex;
        align-items: center;
        padding: 0;
        height: 600px;
    }

    .content-wrapper {
        padding: 0 20px 40px;

        @include min-width(1024) {
            width: 60%;
            padding: 0 160px 0 0;
            display: flex;
            justify-content: flex-end;
        }

        .content {
            @include min-width(1024) {
                width: 960px;
                max-width: 100%;
                flex-shrink: 0;
            }

            .content-items {
                @include min-width(1024) {
                    width: 100%;
                    max-width: 490px;
                    padding: 0 20px;
                    margin: 0 auto;
                }
            }
        }
    }

    .image-wrapper {
        @include min-width(1024) {
            width: 40%;
            height: 100%;
            flex-shrink: 0;
            position: relative;
        }

        :deep(.component-rounded-image) {
            @include min-width(1024) {
                height: 100%;
            }

            .rounded-image {
                @include min-width(1024) {
                    margin: auto 0 auto -160px;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                }
            }

            .rounded-image-background {
                @include min-width(1024) {
                    height: 100%;
                }
            }
        }
    }
}
</style>
